'use client';

import { MACARON } from './tokens';
import type { RecordAny } from '@macaron-a2ui/core/v0_8';

/** 虚线分割：Flutter 用 CustomPaint，这里用 repeating-linear-gradient 近似 */
export function MacaronDivider({ config }: { config: RecordAny }) {
  const vertical = config.axis === 'vertical';
  if (vertical) {
    return (
      <div
        className="shrink-0"
        style={{
          width: 0.5,
          minHeight: 24,
          backgroundImage: `repeating-linear-gradient(to bottom, ${MACARON.dividerDash} 0 2px, transparent 2px 7px)`,
        }}
      />
    );
  }
  return (
    <div
      className="h-px min-w-0 shrink-0 self-stretch"
      style={{
        backgroundImage: `repeating-linear-gradient(to right, ${MACARON.dividerDash} 0 2px, transparent 2px 7px)`,
        backgroundSize: '7px 1px',
      }}
    />
  );
}
